import React from 'react';
import PropTypes from 'prop-types';
import RulesContainer from './RulesContainer';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const ruleKeys = {
    appliance: 'appliance_rules',
    condition: 'conditions_rules',
};

class ApplianceConditionRulesContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rules: props.discountRules,
        };
    }

    formatRules = (rules) => {
        return utils.map(rules, (rule) => {
            return {
                config: rule.config,
                type: rule.type,
            };
        });
    };

    updateRule = (newRules, type) => {
        const { updateRules } = this.props;

        const { rules: currentRules } = this.state;

        const updatedRules = {
            ...currentRules,
            [type]: newRules,
        };

        this.setState({
            rules: updatedRules,
        }, () => {
            const formattedRules = {};

            utils.each(updatedRules, (rules, key) => {
                if (utils.isEmpty(rules)) {
                    formattedRules[ruleKeys[key]] = null;
                    return;
                }

                formattedRules[ruleKeys[key]] = this.formatRules(rules);
            });

            updateRules(formattedRules);
        });
    };

    render() {
        const { rules } = this.state;
        const { translate } = this.props;

        return (
            <div>
                <Title
                    style={ { marginBottom: 17 } }
                    title={ translate(`resources.discounts.rules.title`) }
                />

                {
                    utils.map(rules, (rule, type) => {
                        return (
                            <RulesContainer
                                key={ `rule-${ type }` }
                                type={ type }
                                rules={ rules }
                                onAddRule={ this.updateRule }
                                onUpdateRule={ this.updateRule }
                            />
                        );
                    })
                }
            </div>
        );
    }
}

ApplianceConditionRulesContainer.defaultProps = {
    discountRules: {
        appliance: null,
        condition: null,
    },
};

ApplianceConditionRulesContainer.propTypes = {
    discountRules: PropTypes.shape({
        appliance: PropTypes.arrayOf(PropTypes.shape({
            config: PropTypes.shape({
                attribute: PropTypes.string,
                operator: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.array,
                    PropTypes.bool,
                    PropTypes.string,
                    PropTypes.number,
                    PropTypes.object,
                ]),
            }),
            type: PropTypes.string,
        })),
        condition: PropTypes.arrayOf(PropTypes.shape({
            config: PropTypes.shape({
                attribute: PropTypes.string,
                operator: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.array,
                    PropTypes.bool,
                    PropTypes.string,
                    PropTypes.number,
                    PropTypes.object,
                ]),
            }),
            type: PropTypes.string,
        })),
    }),
    updateRules: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ApplianceConditionRulesContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/ApplianceConditionRulesContainer.js